import {
  HTTPValidationError,
  DeleteExamMetadataQcTasksQcTaskIdExamDeleteResponse,
  DeleteExamMetadataQcTasksQcTaskIdExamDeleteData,
  deleteExamMetadataQcTasksQcTaskIdExamDelete,
} from '@common/config/api/client'
import { queryClient } from '@common/config/api/queryClient'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const useDeleteExamMetadataMutation = (): UseMutationResult<
  DeleteExamMetadataQcTasksQcTaskIdExamDeleteResponse,
  AxiosError<HTTPValidationError>,
  DeleteExamMetadataQcTasksQcTaskIdExamDeleteData
> => {
  return useMutation<
    DeleteExamMetadataQcTasksQcTaskIdExamDeleteResponse,
    AxiosError<HTTPValidationError>,
    DeleteExamMetadataQcTasksQcTaskIdExamDeleteData
  >({
    mutationFn: async (query) => {
      const response = await deleteExamMetadataQcTasksQcTaskIdExamDelete({
        path: query.path,
        query: query.query,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['QCTask'] })
    },
  })
}
